"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var ListingApprovalStatus_1 = require("../ListingApprovalStatus");
var MessageBar_1 = require("office-ui-fabric-react/lib/MessageBar");
var ListingHelper_1 = require("../ListingHelper");
var AppFrame_1 = require("@twii/core-ui-fabric/lib/component/AppFrame");
var Sync_1 = require("@twii/core-ui-fabric/lib/component/Sync");
var HostAppView_1 = require("@twii/core-ui-fabric/lib/component/HostAppView");
var ListingModelSupplier_1 = require("../model/ListingModelSupplier");
var ListingLaunch = /** @class */ (function (_super) {
    __extends(ListingLaunch, _super);
    function ListingLaunch() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListingLaunch.prototype.componentWillMount = function () {
        this.props.host.setTitle(this.props.listing.title);
    };
    Object.defineProperty(ListingLaunch.prototype, "external", {
        get: function () {
            return ListingHelper_1.isExternalListing(this.props.listing);
        },
        enumerable: true,
        configurable: true
    });
    ListingLaunch.prototype.render = function () {
        var listing = this.props.listing;
        if (!listing.is_enabled) {
            return (React.createElement(MessageBar_1.MessageBar, { messageBarType: MessageBar_1.MessageBarType.blocked },
                React.createElement("strong", null, this.props.listing.title),
                " is currently disabled."));
        }
        if (listing.is_deleted) {
            return (React.createElement(MessageBar_1.MessageBar, { messageBarType: MessageBar_1.MessageBarType.blocked },
                React.createElement("strong", null, this.props.listing.title),
                " has been removed and is no longer accessible."));
        }
        if (listing.approval_status !== ListingApprovalStatus_1.ListingApprovalStatus.APPROVED) {
            return (React.createElement(MessageBar_1.MessageBar, { messageBarType: MessageBar_1.MessageBarType.blocked },
                React.createElement("strong", null, this.props.listing.title),
                " is not currently available for use."));
        }
        if (this.external && !this.props.host.root) {
            return React.createElement(AppFrame_1.AppFrame, { src: listing.launch_url, host: this.props.host });
        }
        return null;
    };
    ListingLaunch.prototype.componentDidMount = function () {
        if (!this.external) {
            this.props.host.load({ path: this.props.listing.launch_url });
        }
        else if (this.props.host.root) {
            // this is a bit dodgy
            window.location.assign(this.props.listing.launch_url);
        }
    };
    ListingLaunch.prototype.componentDidUpdate = function () {
        if (!this.external) {
            this.props.host.load({ path: this.props.listing.launch_url });
        }
    };
    ListingLaunch = __decorate([
        mobx_react_1.observer
    ], ListingLaunch);
    return ListingLaunch;
}(React.Component));
var ListingLaunchContainer = /** @class */ (function (_super) {
    __extends(ListingLaunchContainer, _super);
    function ListingLaunchContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onRenderDone = function () {
            return React.createElement(ListingLaunch, { host: _this.props.host, listing: _this.props.listingSupplier.value });
        };
        return _this;
    }
    ListingLaunchContainer.prototype.componentWillMount = function () {
        this.props.listingSupplier.load();
    };
    ListingLaunchContainer.prototype.render = function () {
        return React.createElement(Sync_1.Sync, { sync: this.props.listingSupplier.sync, onRenderDone: this._onRenderDone, syncLabel: "Launching " + (this.props.host.params.title || "") + "..." });
    };
    return ListingLaunchContainer;
}(React.Component));
var ListingLaunchApp = /** @class */ (function (_super) {
    __extends(ListingLaunchApp, _super);
    function ListingLaunchApp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ListingLaunchApp.prototype, "host", {
        get: function () {
            return this.props.match.host;
        },
        enumerable: true,
        configurable: true
    });
    ListingLaunchApp.prototype.componentWillMount = function () {
        this.host.setTitle("" + (this.props.match.params.title || ""));
    };
    Object.defineProperty(ListingLaunchApp.prototype, "listingId", {
        get: function () {
            return this.props.match.params.listingId;
        },
        enumerable: true,
        configurable: true
    });
    ListingLaunchApp.prototype.render = function () {
        return (React.createElement(HostAppView_1.HostAppView, { host: this.host },
            React.createElement(ListingLaunchContainer, { host: this.host, listingSupplier: new ListingModelSupplier_1.ListingModelSupplier(this.listingId) })));
    };
    return ListingLaunchApp;
}(React.Component));
exports.ListingLaunchApp = ListingLaunchApp;
exports.default = ListingLaunchApp;
